import React from 'react';
import { Link } from 'react-router-dom';
import ObfuscatedEmail from './ObfuscatedEmail';
import '../styles/Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="apple-footer">
      <div className="apple-footer-inner">
        <p className="apple-footer-note">
          미라이쥬쿠는 일본 대학 입시 정보를 참고용으로 제공합니다. 지원 자격·일정·과목은 각 대학 모집요항 원문으로 확인하세요.
        </p>

        <div className="apple-footer-cols">
          <div>
            <h4>탐색</h4>
            <Link to="/guides">가이드</Link>
            <Link to="/finder">루트 찾기</Link>
            <Link to="/checklist">요강 체크</Link>
            <Link to="/compare">대학 비교</Link>
            <Link to="/glossary">용어집</Link>
            <Link to="/calendar">일정</Link>
            <Link to="/alerts">시즌 알림</Link>
            <Link to="/pass">시즌패스</Link>
            <Link to="/resources">공식 자료</Link>
            <Link to="/universities">대학 입시</Link>
            <Link to="/consulting">신청</Link>
            <Link to="/about">소개</Link>
          </div>
          <div>
            <h4>계정</h4>
            <Link to="/dashboard">마이페이지</Link>
            <Link to="/courses">아카이브</Link>
          </div>
          <div>
            <h4>법적 고지</h4>
            <Link to="/terms">이용약관</Link>
            <Link to="/privacy">개인정보처리방침</Link>
            <Link to="/refund">환불 정책</Link>
          </div>
        </div>

        <div className="apple-footer-legal">
          <p>Copyright © {currentYear} 미라이쥬쿠(未来塾). All rights reserved.</p>
          <p className="apple-footer-meta">
            주식회사 미라이쥬쿠 · 대표 박민준 · 565-09-02809 · <ObfuscatedEmail />
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
